module.exports = __webpack_public_path__ + "static/media/ROCC____.29d3f929.TTF";